export default "__VITE_ASSET__DK442B6z__"